import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { GoToStepAction } from './actions';
import { LeadService } from 'src/app/services/lead.service';

@Injectable()
export class NmjParentEffects {
    constructor(private actions$: Actions,
        private leadService: LeadService) {
    }

    recordPageChange$ = createEffect(() => this.actions$.pipe(
        ofType(GoToStepAction),
        switchMap((action: any) => this.leadService.addLeadWorkflowMetric(action.index).pipe(
            catchError(_err => {
                return EMPTY;
            })
        )),
    ), {dispatch:false});
}
